import { MetricField } from "../../gql-generated/types";

export const statsFields = [MetricField.LensViews, MetricField.LensShares, MetricField.LensPlays];
